import React, { memo } from 'react';
import moment from 'moment-jalaali';

import { convertDigitToProperFormat } from 'utils/number';
import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';

type validFormats = 'date' | 'hours' | 'datetime';

const getDateFormat: { [key in validFormats]: string } = {
  date: 'jYYYY/jMM/jD',
  hours: 'HH:mm',
  datetime: 'jYYYY/jMM/jD HH:mm',
};

const DateCombo: React.FC<IPrintPartProps<'dueDate' | 'startDate'>> = ({
  item,
  taskId,
}) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { allTasks, company } = dataContext;
      const {
        part,
        options: { view, format, customTitle },
      } = item;

      const showBothKeyValue = view === 'both';
      let showKey = showBothKeyValue;
      let showValue = showBothKeyValue;

      if (!showBothKeyValue) {
        showKey = view === 'key';
        showValue = view === 'value';
      }

      let keyTitle;
      let valueTitle;

      if (showKey) {
        const templateId = allTasks!.find(
          (task) => task.id === taskId
        )!.templateId;
        const companyTemplate = company!.templates?.find(
          (template) => template.taskId === templateId
        );
        const whichTitle = `${part}Title` as 'dueDateTitle' | 'startDateTitle';
        keyTitle = messages.getDateTitle(
          part,
          showBothKeyValue,
          customTitle ? customTitle : companyTemplate!.task![whichTitle]
        );
      }
      if (showValue) {
        const task = allTasks!.find((task) => task.id === taskId)!;
        const startDate =
          task.startDate &&
          convertDigitToProperFormat(
            moment(task.startDate).format(getDateFormat[format])
          );
        const dueDate =
          task.dueDate &&
          convertDigitToProperFormat(
            moment(task.dueDate).format(getDateFormat[format])
          );
        if (startDate && dueDate) {
          valueTitle = messages.from + startDate + messages.until + dueDate;
        } else if (startDate) {
          valueTitle = messages.from + startDate + messages.continues;
        } else if (dueDate) {
          valueTitle = messages.until + dueDate;
        }
      }
      return (
        <SingleTaskPart>
          <span>{showKey && keyTitle}</span>
          <span>{showValue && valueTitle}</span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(DateCombo);
